import React from "react";

export const numberInputKeyDownValidation = (
  e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  excludeSymbols: string[] = [],
) => {
  ["e", "-", ...excludeSymbols].includes(e.key.toLowerCase()) &&
    e.preventDefault();
};
